import * as __NgCli_locale_1 from "@angular/common/locales/ko";
import * as __NgCli_locale_2 from "@angular/common";
__NgCli_locale_2.registerLocaleData(__NgCli_locale_1.default);
import { Location } from '@angular/common';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./compat/compat.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
// FIXME: remove that when URL consistency has been fixed in GAF
Location.stripTrailingSlash = function _stripTrailingSlash(url) {
    return url;
};
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.CompatModuleNgFactory, {
    preserveWhitespaces: false,
});
